/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthConfigResponse } from '../../models/auth-config-response';
import { CreateAuthConfigInput } from '../../models/create-auth-config-input';

export interface TenantAuthConfigPost$Params {
  'Active-Tenant-Identifier': string;
      body: CreateAuthConfigInput
}

export function tenantAuthConfigPost(http: HttpClient, rootUrl: string, params: TenantAuthConfigPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthConfigResponse>> {
  const rb = new RequestBuilder(rootUrl, tenantAuthConfigPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthConfigResponse>;
    })
  );
}

tenantAuthConfigPost.PATH = '/auth-configurations';
